import {atom} from "recoil";
import keys from "configs/atoms";

const campaignDateRangeIDAtom = atom(({
    key: keys.Statistic.CampaignDateRangeID,
    default: 0
}));

export default campaignDateRangeIDAtom;
